import { mdiTruck } from '@mdi/js';
import { Avatar, SvgIcon, Theme, Typography } from '@mui/material';
import React, { ReactElement } from 'react';
import { Link, useParams } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';

import PrimaryButton from '../../../../components/buttons/primaryButton';
import P4 from '../../../../components/typography/p4';

// import useSubRoutes, { STORE_SUB_ROUTES } from '../../pages/useSubRoutes';

interface Props {
	ignoreCompletedOrders?: boolean;
	storeName: string;
}

const ClosedStore = (props: Props): ReactElement => {
	const { classes } = useStyles();
	const { storeId } = useParams();
	// const url = useSubRoutes();

	return (
		<div className={classes.container}>
			<Typography className={classes.title} variant="h2">
				Ordering for {props.storeName} has completed!
			</Typography>
			<Avatar className={classes.avatar}>
				<SvgIcon>
					<path d={mdiTruck} />
				</SvgIcon>
			</Avatar>
			<P4 className={classes.title}>
				Thank you for ordering with Breakmark! Watch your email in the coming weeks for updates to your order.
			</P4>
			{props.ignoreCompletedOrders !== true && (
				<div className={classes.backToOrders}>
					<PrimaryButton component={Link} to={`/store/${storeId}/orders`}>
						View Completed Orders
					</PrimaryButton>
				</div>
			)}
		</div>
	);
};

const useStyles = makeStyles()((theme: Theme) => {
	return {
		container: {
			maxWidth: 1100,
			marginLeft: 'auto',
			marginRight: 'auto',
			textAlign: 'center',
			marginBottom: '40px'
		},
		avatar: {
			marginLeft: 'auto',
			marginRight: 'auto',
			backgroundColor: '#199cdb',
			width: 80,
			height: 80,
			'& svg': {
				width: 60,
				height: 60
			}
		},
		title: {
			marginTop: '30px',
			marginBottom: '30px'
		},
		backToOrders: {
			marginTop: 20,
			textAlign: 'center',
			width: '100%'
		}
	};
});

export default ClosedStore;
